// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vl-upload__files {
  display: none !important;
}
.vl-upload__file.dz-error:before,
.vl-upload__file--error:before {
  content: "\\f173" !important;
}
.vl-upload.readonly .vl-upload__file__close {
  display: none;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
